import type { Follow } from "@tandemdiabetes/sugarmate-api-react-client"
import { CaretRightIcon } from "@tandemdiabetes/sugarmate-react-components"
import { Link } from "@tanstack/react-router"
import styles from "./Sharer.module.scss"
import { followToSharer } from "src/utils"

interface FollowProps {
  follow: Follow;
}

/*
 * display info about a follow relationship in which someone is sharing data with the user
 */
export function Sharer(props: FollowProps) {
  const { follow } = props

  return (
    <Link
      to={"/data_sharing/following/$followId/manage_following"}
      params={{ followId: follow.id }}
      className={styles.sharerContainer}
    >
      <div
        className={styles.sharerName}
        id="following-user"
      >
        {followToSharer(follow)}
      </div>
      <CaretRightIcon
        width={20}
        height={20}
      />
    </Link>
  )
}
